import React from "react";
import { AppStoreButton } from "react-mobile-app-button";

export default function IOSDownloadButton({ url }) {
  return (
    <AppStoreButton
      url={url}
      theme={"light"}
      className={"custom-style"}
      width={220}
      height={65}
    />
  );
}
